module.exports = __webpack_public_path__ + "img/logo-b.129ffb79.svg";